import CameraControls from "camera-controls";

import { Context } from "../../../context";
import { ControllerStrategy } from "../strategy";

export class ZoomDollyControllerStrategy extends ControllerStrategy {
  private configured = false;

  private pointerDownCb = (ev: PointerEvent) => {
    if (this.configured || !this.registered) return;
    if (ev.pointerType == "touch") {
      const controls = this.registered.controls;
      if (controls) {
        // configure zoom sensitivity for touch
        controls.dollySpeed = this.registered.state.zoomConfig.dolly.speedTouch;
      }
    }
    this.configured = true;
  };

  init(context: Context): ControllerStrategy {
    super.init(context);

    if (!this.registered) return this;

    const { controls, domRef } = this.registered;

    if (controls) {
      controls.minDistance = this.registered.state.zoomConfig.dolly.min;
      controls.maxDistance = this.registered.state.zoomConfig.dolly.max;

      controls.dollySpeed = this.registered.state.zoomConfig.dolly.speed;

      controls.mouseButtons.wheel = CameraControls.ACTION.DOLLY;
      controls.touches.two = CameraControls.ACTION.TOUCH_DOLLY_TRUCK;
    }

    domRef.addEventListener("pointerdown", this.pointerDownCb);

    return this;
  }

  teardown() {
    super.teardown();

    if (!this.registered) return this;

    const { controls, domRef } = this.registered;
    if (controls) {
      controls.dollySpeed = 1;
    }
    domRef.removeEventListener("pointerdown", this.pointerDownCb);
  }
}
